/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ICreateAsynchronousPayment,
    ICreateAsynchronousPaymentError,
    ICreateAsynchronousPaymentViewProps
} from './create-asynchronous-payment';

const CreateAsynchronousPaymentContent: React.FC<ICreateAsynchronousPayment> = ({ asynchronousPaymentContainer, button, summary }) => {
    return (
        <Node {...asynchronousPaymentContainer}>
            {' '}
            {button} {summary}{' '}
        </Node>
    );
};

const ErrorMessage: React.FC<ICreateAsynchronousPaymentError> = ({ error, title, message }) => {
    return (
        <Node {...error}>
            {title}
            {message}
        </Node>
    );
};

const CreateAsynchronousPaymentView: React.FC<ICreateAsynchronousPaymentViewProps> = props => {
    const {
        createAsynchronousPayment,
        createAsynchronousPaymentErrorRef,
        createAsynchronousPaymentContent,
        errorMessage,
        viewState
    } = props;

    return (
        <Module {...createAsynchronousPayment} ref={createAsynchronousPaymentErrorRef}>
            {viewState.isError && errorMessage && <ErrorMessage {...errorMessage} />}
            <CreateAsynchronousPaymentContent {...createAsynchronousPaymentContent} />
        </Module>
    );
};

export default CreateAsynchronousPaymentView;
